import { Component } from '@angular/core';
import { AngularProgressBarComponent } from '../angular-progress-bar/angular-progress-bar.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { AchievementService } from '../service/achievement.service';
import { UserProfileService } from '../service/user-profile.service';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ThemePalette } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { Location } from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
@Component({
  selector: 'app-achievement',
  standalone: true,
  imports: [
    CommonModule,
    AngularProgressBarComponent,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatProgressSpinnerModule,
    RouterLink,
    TranslateModule,
    MatExpansionModule,
    MatButtonModule,
  ],
  templateUrl: './achievement.component.html',
  styleUrl: './achievement.component.css'
})
export class AchievementComponent {
  color : ThemePalette = 'accent';
  percent = '75';
  isLoading = false;
  apexId!:string;
  myAchievementObjectArray!:any;
  myAwards!:any;
  more = '';
  less = '';
  browserLangToUse = '';
  constructor(
    private userProfileService: UserProfileService,
    private achievementService: AchievementService,
    translate: TranslateService,
    private location: Location,
  ) {
    translate.setDefaultLang('en');
    let browserLangToUse = '';
    let browserLang = translate.getBrowserLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    translate.use(browserLangToUse);
    this.browserLangToUse = browserLangToUse;
    translate.get('ml_144130').subscribe((res: string) => {
      this.more = res;
      this.moreOrLess = this.more;      
    });
    translate.get('ml_151204').subscribe((res: string) => {
      this.less = res;
    });
  }
  achievementIdObjectMap!:Map<string,any>;
  milestoneObjectArray!:any[];
  totalMilesage = 0;
  totalMilesageStartDay = '';
  totalCylinder = 0;
  totalCylinderStartDay = '';
  private pageInitialization(apexId:string): void {
    this.achievementIdObjectMap = new Map();

    this.achievementService.getAchievementByApexId(apexId).subscribe(responseAchievementObjectArray => {
      this.myAchievementObjectArray = responseAchievementObjectArray;
      this.myAwards = this.myAchievementObjectArray.myAwards.sort(this.sortByDate);
      
      for (const myAchievementObject of this.myAchievementObjectArray.myAchievements){
        let completePercent = Math.round( myAchievementObject.achieveValue / myAchievementObject.milestone * 100 );
        if(completePercent > 100){
          myAchievementObject.completePercent = 100;
        }
        else if(completePercent < 0){
          myAchievementObject.completePercent = 0;
        }
        else{
          myAchievementObject.completePercent = completePercent;
        }
        
        if(myAchievementObject.achievementName === 'Total Mileage'){
          this.totalMilesage = myAchievementObject.achieveValue;
          this.totalMilesageStartDay = this.formatDateString(myAchievementObject.achievementInitDate);
        }
        if(myAchievementObject.achievementName === 'Number of Cylinders Delivered'){
          this.totalCylinder = myAchievementObject.achieveValue;
          this.totalCylinderStartDay = this.formatDateString(myAchievementObject.achievementInitDate);
        }
      }
      this.achievementService.getMilestoneByApexId(apexId).subscribe(responseMilestoneObjectArray => {
        if(responseMilestoneObjectArray.length === 0){
          for (const myAchievementObject of this.myAchievementObjectArray.myAchievements){
            myAchievementObject.achievedMilestoneObject = null;
          }
        }
        else{
          
          for (const milestoneObject of responseMilestoneObjectArray){
            let key = milestoneObject.achievementId;
            if(this.achievementIdObjectMap.has(key)){
              let groupedMilestone = this.achievementIdObjectMap.get(key);
              groupedMilestone.milestoneArray.push(milestoneObject);
              this.achievementIdObjectMap.set(key, groupedMilestone);
            }
            else{
              let newMilestoneArray = [];
              newMilestoneArray.push(milestoneObject);
              let groupedMilestone : any = { achievementId:milestoneObject.achievementId, 
                achievementName:milestoneObject.achievementName, 
                achievement_Translation_Id:milestoneObject.achievement_Translation_Id, 
                milestoneArray: newMilestoneArray };
              this.achievementIdObjectMap.set(key, groupedMilestone);
            }                        
          }
          for (const key of this.achievementIdObjectMap.keys()) {
            console.log(key);
          }
          for (const value of this.achievementIdObjectMap.values()) {
            console.log(value);
          }
          for (const myAchievementObject of this.myAchievementObjectArray.myAchievements){
            let foundObject = this.achievementIdObjectMap.get(myAchievementObject.achievementId);
            if(foundObject === undefined){
              myAchievementObject.achievedMilestoneObject = null;
            }
            else{
              myAchievementObject.achievedMilestoneObject = this.achievementIdObjectMap.get(myAchievementObject.achievementId);
            }
          }
          
          for (const myAchievementObject of this.myAchievementObjectArray.myAchievements){
            if(myAchievementObject.achievedMilestoneObject !== null){
              myAchievementObject.achievedMilestoneObject.milestoneArray = myAchievementObject.achievedMilestoneObject.milestoneArray.sort(this.sortByMilestoneDate);
            }
            
          }

        }
        
        
        this.isLoading = false;
      });

      
    });
  }
  numberWithCommas(x:number):string {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
  driverStartDate = '';
  driverServiceDay = 0;
  driverBusinessType = '';
  ngOnInit(): void {
    this.isLoading = true;
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      let apexId = localStorage.getItem("apexid");
      this.apexId = apexId!;
      if(apexId !== null){        
        this.pageInitialization(apexId);
      }
      let driverStartDate = localStorage.getItem("driverStartDate");
      if(driverStartDate !== null){
        this.driverStartDate = driverStartDate;        
      }
      let driverBusinessType = localStorage.getItem("driverBusinessType");
      if(driverBusinessType !== null){
        this.driverBusinessType = driverBusinessType;        
      }
    }
    else{
      let overrideObject = JSON.parse(overrideObjectString);
      let apexId = overrideObject.apexid;
      this.apexId = apexId;
      this.pageInitialization(apexId);
      this.driverStartDate = overrideObject.driverStartDate;
      this.driverBusinessType = overrideObject.driverBusinessType;
    }
    this.driverServiceDay = this.getServiceDay(this.driverStartDate);
  }
  getServiceDay(startDateString:string):number{
    let day = 0;
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const startDate = new Date(startDateString);
    
    const dateNow = Date.now();

    day = Math.round( Math.abs( ( startDate.valueOf() - dateNow.valueOf() ) / oneDay ) );
    
    return day;
  }
  formatDate(dateString:string): string{
    
    return dateString.split('T')[0].substring(0,7);
  }
  
  backClicked() {
    this.location.back();
  }
  toShowMoreAward = false;
  moreOrLess = 'More';
  showMoreAward() {
    if(this.toShowMoreAward){
      this.toShowMoreAward = false;
      this.moreOrLess = this.more;
    }
    else{
      this.toShowMoreAward = true;
      this.moreOrLess = this.less;
    }
    
  }
  formatDateString(dateString :any): string{
    let formattedDateString = '';
    if(dateString === null){

    }
    else if(dateString === ''){

    }
    else{
      formattedDateString = dateString.split('T')[0];
    }
    return formattedDateString;
  }
  sortByDate(a:any, b:any) {
    var keyA = new Date(a.awardDate),
      keyB = new Date(b.awardDate);
    // Compare the 2 dates
    if (keyA < keyB) return 1;
    if (keyA > keyB) return -1;
    return 0;
  }

  sortByMilestoneDate(a:any, b:any) {
    var keyA = new Date(a.milestoneDate),
      keyB = new Date(b.milestoneDate);
    // Compare the 2 dates
    if (keyA < keyB) return 1;
    if (keyA > keyB) return -1;
    return 0;
  }

}
